import {
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Box,
  Container,
  Typography,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormLabel,
  Checkbox,
  Button,
  Paper
} from '@mui/material';
import React, { useState, useEffect } from 'react'
import { motion } from 'framer-motion';
import { Grid, keyframes } from '@mui/system';
import { db} from "./../../firebase";
import { getFirestore, collection, addDoc } from 'firebase/firestore';
import { getDocs } from "firebase/firestore"; 
// Gujarat districts and talukas data
const gujaratData = {
  Ahmedabad: ['Daskroi', 'Detroj-Rampura', 'Dhandhuka', 'Dholera', 'Dholka', 'Mandal', 'Sanand', 'Viramgam'],
  Amreli: ['Amreli', 'Babra', 'Bagasara', 'Dhari', 'Jafrabad', 'Khambha', 'Kunkavav Vadia', 'Lathi', 'Rajula', 'Savarkundla'],
  Anand: ['Anand', 'Anklav', 'Borsad', 'Khambhat', 'Petlad', 'Sojitra', 'Tarapur', 'Umreth'],
  Bharuch: ['Amod', 'Anklesvar', 'Bharuch', 'Hansot', 'Jambusar', 'Jhagadia', 'Vagra', 'Valia'],
  Bhavnagar: ['Bhavnagar', 'Gariadhar', 'Ghogha', 'Mahuva', 'Palitana', 'Sihor', 'Talaja', 'Vallabhipur'],
  Gandhinagar: ['Dehgam', 'Gandhinagar', 'Kalol', 'Mansa'],
  Jamnagar: ['Dhrol', 'Jamnagar', 'Jodiya', 'Kalavad', 'Lalpur', 'Okhamandal'],
  Rajkot: ['Dhoraji', 'Gondal', 'Jasdan', 'Jetpur', 'Kotda Sangani', 'Lodhika', 'Paddhari', 'Rajkot', 'Upleta', 'Vinchiya'],
  Surat: ['Bardoli', 'Choryasi', 'Kamrej', 'Mahuva', 'Mandvi', 'Mangrol', 'Olpad', 'Palsana', 'Umarpada'],
  Vadodara: ['Dabhoi', 'Karjan', 'Padra', 'Savli', 'Sinor', 'Vadodara', 'Waghodia']
};

function Kaushalyasetuform() {
  const years = Array.from({ length: 10 }, (_, index) => new Date().getFullYear() - index);
  const fadeInSlideUp = keyframes`
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
    `;
  const fadeIn = {
    initial: { opacity: 0, y: 20 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.6 }
  };
  const [formData, setFormData] = useState({
    fullName: '',
    mothername:'',
    aadharno:'',
    passingyear:'',
    rollno:'',
    previousschool:'',
    address:'',
    schoolname:'',
    email: '',
    phone: '',
    alterphone:'',
    district: '',
    taluka: '',
    gender: 'male',
    department: '',
    interests: [],
    message: ''
  });

  const [talukas, setTalukas] = useState([]);

  const departments = [
    'Engineering',
    'Marketing',
    'Sales',
    'Human Resources',
    'Finance',
    'Other'
  ];

  const interests = [
    'Web Development',
    'Mobile Development',
    'UI/UX Design',
    'Data Science',
    'Cloud Computing'
  ];

  useEffect(() => {
    if (formData.district) {
      setTalukas(gujaratData[formData.district] || []);
      setFormData(prev => ({ ...prev, taluka: '' }));
    }
  }, [formData.district]);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const fetchData = async () => {
    const querySnapshot = await getDocs(collection(db, "tables"));
    querySnapshot.forEach((doc) => {
      console.log(doc.id, " => ", doc.data());
    });
  };
  const handleInterestChange = (interest) => {
    setFormData(prev => ({
      ...prev,
      interests: prev.interests.includes(interest)
        ? prev.interests.filter(i => i !== interest)
        : [...prev.interests, interest]
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    
    try {
      console.log("form data ",formData);
      // fetchData();  
      // console.log('Attempting to submit:', testData);
      await addDoc(collection(db, "Kaushalyasetu-table"), formData);

      // console.log("Document written with ID: ", docRef.id);
      alert("Form submitted successfully!");
      
      // Clear form fields
      
    } catch (error) {
      console.error("Error adding document: ", error);
      console.error("Error message:", error.message);
      alert("Error submitting form!");
    }
    
    setFormData({
      fullName: '',
      mothername:'',
      aadharno:'',
      passingyear:'',
      rollno:'',
      previousschool:'',
      address:'',
      schoolname:'',
      email: '',
      phone: '',
      alterphone:'',
      district: '',
      taluka: '',
      gender: 'male',
      department: '',
      interests: [],
      message: ''
    });
    console.log('Form submitted:', formData);
  };

  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Paper elevation={3} sx={{ p: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom sx={{ color: '#003733', textAlign: 'center', mb: 4 }}>
        Kaushalya Setu Registration Form
        </Typography>

        <Box component="form" onSubmit={handleSubmit} sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
          {/* Basic Information */}
          <Box sx={{ display: 'grid', gap: 2, gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' } }}>
            <TextField
              fullWidth
              label="Student's Name"
              name="fullName"
              value={formData.fullName}
              onChange={handleChange}
              required
              sx={{ '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#003733' } }}
            />
            <TextField
              fullWidth
              label="Student's Mother Name"
              name="mothername"
              value={formData.mothername}
              onChange={handleChange}
              required
              sx={{ '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#003733' } }}
            />
            <TextField
              fullWidth
              label="Aadhar Card No."
              name="aadharno"
              value={formData.aadharno}
              onChange={handleChange}
              required
            />

            <TextField
              select
              fullWidth
              label="SSC Exam Year"
              name="passingyear"
              value={formData.passingyear}
              onChange={handleChange}
              variant="outlined" // or "filled" / "standard" based on your design preference
            >
              {years.map((year) => (
                <MenuItem key={year} value={year}>
                  {year}
                </MenuItem>
              ))}
            </TextField>

            <TextField
              fullWidth
              label="Roll No."
              name="rollno"
              type="text"
              value={formData.rollno}
              onChange={handleChange}
              required
            />

            <TextField
              fullWidth
              label="Previous School"
              name="previousschool"
              type="text"
              value={formData.previousschool}
              onChange={handleChange}

            />
            <TextField
              fullWidth
              label="Phone Number"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              required
            />
            <TextField
              fullWidth
              label="Alternate Phone Number"
              name="alterphone"
              value={formData.alterphone}
              onChange={handleChange}
            />
            <TextField
              fullWidth
              label="Email"
              name="email"
              type="email"
              value={formData.email}
              onChange={handleChange}
              required
            />
            {/* Gender Selection */}
            <FormControl>
              <FormLabel>Gender</FormLabel>
              <RadioGroup
                row
                name="gender"
                value={formData.gender}
                onChange={handleChange}
              >
                <FormControlLabel value="male" control={<Radio />} label="Male" />
                <FormControlLabel value="female" control={<Radio />} label="Female" />
                <FormControlLabel value="other" control={<Radio />} label="Other" />
              </RadioGroup>
            </FormControl>


          </Box>
          <TextField
            fullWidth
            label="Address  "
            name="address"
            value={formData.address}
            onChange={handleChange}
            multiline
            rows={4}
          />
          {/* Location Selection */}
          <Box sx={{ display: 'grid', gap: 2, gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' } }}>
            <FormControl fullWidth>
              <InputLabel>District</InputLabel>
              <Select
                name="district"
                value={formData.district}
                onChange={handleChange}
                label="District"
                required
              >
                {Object.keys(gujaratData).map((district) => (
                  <MenuItem key={district} value={district}>
                    {district}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl fullWidth>
              <InputLabel>Taluka</InputLabel>
              <Select
                name="taluka"
                value={formData.taluka}
                onChange={handleChange}
                label="Taluka"
                disabled={!formData.district}
                required
              >
                {talukas.map((taluka) => (
                  <MenuItem key={taluka} value={taluka}>
                    {taluka}
                  </MenuItem>
                ))}
              </Select>

            </FormControl>
          </Box>
               <TextField
                 
                 label="School Name"
                 name="schoolname"
                 type="text"
                 value={formData.schoolname}
                 onChange={handleChange}
                 required
               />
         
              {/* Department Selection */}
              <FormControl >
               
                <InputLabel>Department</InputLabel>
                <Select
                  name="department"
                  value={formData.department}
                  onChange={handleChange}
                  label="Department"
                  required
                >
                  {departments.map((dept) => (
                    <MenuItem key={dept} value={dept}>
                      {dept}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
           







          {/*   Interests */}
          {/* <FormControl>
            <FormLabel>Areas of Interest</FormLabel>
            <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' }, gap: 1 }}>
              {interests.map((interest) => (
                <FormControlLabel
                  key={interest}
                  control={
                    <Checkbox
                      checked={formData.interests.includes(interest)}
                      onChange={() => handleInterestChange(interest)}
                    />
                  }
                  label={interest}
                />
              ))}
            </Box>
          </FormControl>

          {/* Message */}
          {/* <TextField
            fullWidth
            label="Additional Message"
            name="message"
            value={formData.message}
            onChange={handleChange}
            multiline
            rows={4}
          /> */} 

          {/* Submit Button */}
          <Button
            type="submit"
            variant="contained"
            size="large"
            sx={{
              bgcolor: '#003733',
              '&:hover': {
                bgcolor: '#004d48'
              }
            }}
          >
            Submit
          </Button>
        </Box>
      </Paper>
    </Container>
  );
}

export default Kaushalyasetuform
// const collectionRef = db.collection('Kaushalyasetu-table');  // Use correct name
// collectionRef.get()
//   .then((querySnapshot) => {
//     querySnapshot.forEach((doc) => {
//       console.log(doc.id, ' => ', doc.data());
//     });
//   })
//   .catch((error) => {
//     console.log('Error getting documents: ', error);
//   });